import { Box, Button, Drawer, DrawerBody, DrawerCloseButton, DrawerContent, DrawerHeader, DrawerOverlay, VStack, useDisclosure } from '@chakra-ui/react'
import { useRef } from 'react'
import { FaBars } from 'react-icons/fa6'
import Categorie from './Categorie'
import { useAppSelector } from 'src/redux/hooks'

const CategoriesMenuBar = () => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const btnRef = useRef<any>()
  const {categories} = useAppSelector((state)=>state.question)

  return (
    <Box display={{ base: 'block', xl: 'none' }} >
      <Button ref={btnRef} variant='ghost' onClick={onOpen}>
        <FaBars className='text-3xl' />
      </Button>
      <Drawer
        isOpen={isOpen}
        placement='left'
        onClose={onClose}
        finalFocusRef={btnRef}
        size={{ base: 'xs', md: 'md' }}
      >
        <DrawerOverlay />
        <DrawerContent  >
          <DrawerCloseButton />
          <DrawerHeader>Categories</DrawerHeader>
          <DrawerBody >
            <VStack alignItems='flex-start' >
              {categories && categories?.length > 0 && categories?.map((c, index) => (
                <Categorie index={index} categorie={c} key={index} />
              ))}
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>

    </Box>
  )
}

export default CategoriesMenuBar